import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';
import { Link } from 'react-router-dom';

const Requestform = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  return (
    <section
      className="bg-[#111820] py-20 md:py-28 px-6 border-t border-white/5"
      id="contact"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className={`max-w-6xl mx-auto ${isRTL ? 'font-arabic' : ''}`}>
        {/* Centered heading block on its own row */}
        <div className="text-center mb-12 md:mb-16">
          <motion.h2
            className="text-[#97d700] text-4xl font-bold font-magistral mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            {t.form_title}
          </motion.h2>
          <div className="w-16 h-1 bg-[#97d700] mx-auto mb-6" />
          <motion.p
            className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto leading-[1.9]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            {t.form_subtitle}
          </motion.p>
        </div>

        {/* Constrained form */}
        <motion.div
          className="max-w-xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <form action="https://formspree.io/f/xleqrjlp" method="POST">
            <div className="flex flex-col gap-4">
              <input
                className="p-3 w-full rounded-lg bg-[#1a2530] border border-white/10 text-white placeholder-gray-500 focus:border-[#97d700] focus:outline-none transition-colors duration-200"
                type="email"
                name="email"
                placeholder={t.form_email}
                required
              />
              <textarea
                className="p-3 w-full rounded-lg bg-[#1a2530] border border-white/10 text-white placeholder-gray-500 focus:border-[#97d700] focus:outline-none transition-colors duration-200 resize-none"
                name="message"
                placeholder={t.form_message}
                rows={5}
                required
              />
              <button
                type="submit"
                className="bg-[#97d700] text-black rounded-lg font-semibold w-full sm:w-[200px] mx-auto px-6 py-3 hover:bg-[#a8e600] transition-colors duration-200"
              >
                {t.form_submit}
              </button>
            </div>
          </form>
          <p className="text-gray-400 text-sm mt-6 text-center">
            {t.form_privacy_prefix}{' '}
            <Link to="/privacy-policy" className="text-[#97d700] hover:underline">
              {t.form_privacy_link}
            </Link>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Requestform;
